<template lang="pug">
  .payment-report
    //Loader
    v-progress-linear.mt-0(
      indeterminate
      :color="colors.complement"
      v-if="loading"
      style="position: absolute;"
      )
    //Auth Modal
    ModalSupervisor(
      :available="showModal" 
      title="REIMPRESIÓN DE DOCUMENTOS"  
      @check-key="auth()"
      confirmMessage="Autorizar Emisión de Reportes"
      style="opacity: 0; position: fixed; top:0px; left:0px; margin-left: -1000px;"
      @closed="$router.push('/')"
      )
    v-card.pt-4(v-if="showList")
      v-layout(wrap)
        v-flex.xs6.px-3
          label Fecha Inicio
          DateField(
            label="Fecha Inicio"
            outline
            :disabled="loading"
            v-model="initDate")
        v-flex.xs6.px-3
          label Fecha Fin
          DateField(
            label="Fecha Fin"
            outline
            :disabled="loading"
            v-model="endDate")
        v-flex.xs6.px-3.pb-3
          v-btn.primary(
            block
            :disabled="loading"
            @click="commitFetchReport"
            ) CARGAR REPORTE
        v-flex.xs6.px-3.pb-3
          v-btn(
            block
            :color="colors.complement"
            :dark="!loading"
            :disabled="loading"
            @click="getXLSX"
            ) DESCARGAR EXCEL
      v-data-table( 
        hide-actions
        :items="formattedData"
        :headers="headers"
        )
        template(slot="items" slot-scope="props")
          td {{props.item.id}}
          td {{props.item.fecha_pago}}
          td {{props.item.hora_pago}}
          td {{props.item.rut_cliente}}
          td {{props.item.razon_social_cliente}}
          td {{props.item.total}}
          td(v-html="props.item.documentosFormatted") 
          td(v-html="props.item.pagosFormatted") 
             
</template>

<script>
import axios from 'axios'
import XLSX from 'xlsx'
import { mapActions, mapGetters } from 'vuex'

import ModalSupervisor from '@/components/SupervisorUniqueKey/Modal'
import DateField from '../../components/reusable_components/next/Fields/DateField'

const initialState = () => ({
    loading: false,
    data: [],
    showModal: true,
    initDate: null,
    endDate: null,
    showList: false,
    headers: [
        { text: 'FOLIO', value: 'id' },
        { text: 'FECHA DE PAGO', value: 'fecha_pago' },
        { text: 'HORA DE PAGO', value: 'hora_pago' },
        { text: 'RUT CLIENTE', value: 'rut_cliente' },
        { text: 'RAZON SOCIAL CLIENTE', value: 'razon_social_cliente' },
        { text: 'TOTAL', value: 'total' },
        { text: 'DOCUMENTOS', value: 'documentosFormatted' },
        { text: 'MEDIOS DE PAGO', value: 'pagosFormatted' },
    ],
})
export default {
    name: 'payment-report',
    components: { ModalSupervisor, DateField },
    data: () => initialState(),
    computed: {
        ...mapGetters('AuthModule', [
            'cashDeskID',
            'branchOfficeID',
            'branchOfficeName',
        ]),
        formattedData() {
            if (!this.data || !this.data.length) return []
            return this.data.map(row => {
                row.documentosFormatted = row.documentos.reduce((str, doc) => {
                    let aux = doc.split('$')
                    let docName = aux[0].trim()
                    let docAmount = '$' + aux[1].trim()
                    str += `<tr>
                      <td>${docName}</td>
                      <td>${docAmount}</td>
                      <td></td>
                    </tr>`
                    return str
                }, '<table cellpadding="0" cellspacing="0">')
                row.documentosFormatted += '</table>'
                row.pagosFormatted = row.medios_pago.reduce((str, pago) => {
                    let aux = pago.split('$')
                    let paymentType = aux[0].trim()
                    let paymentAmount = '$' + aux[1].trim()
                    str += `<tr>
                      <td>${paymentType}</td>
                      <td>${paymentAmount}</td>
                      <td></td>
                    </tr>`
                    return str
                }, '<table cellpadding="0" cellspacing="0">')
                row.pagosFormatted += '</table>'
                return row
            })
        },
        printData() {
            let data = []
            let cols = this.headers.map(h => {
                return { name: h.text, key: h.text }
            })
            data[0] = cols.map(col => col.name)
            this.formattedData.forEach(item => {
                let row = []
                this.headers.forEach(h => {
                    if (h.value === 'pagosFormatted')
                        row.push(
                            item.medios_pago.reduce(
                                (str, pago) => (str += pago + '\n'),
                                ''
                            )
                        )
                    else if (h.value === 'documentosFormatted')
                        row.push(
                            item.documentos.reduce(
                                (str, doc) => (str += doc + '\n'),
                                ''
                            )
                        )
                    else row.push(item[h.value])
                })
                data.push(row)
            })
            /*
            let totals = cols.map(c => {
                let val = ''
                switch (c.name) {
                    case 'TOTAL':
                        val = this.calcTotal
                        break
                    case 'MONTO MEDIO DE PAGO':
                        val = this.calcPaymentMethodTotal
                        break
                }
                return val
            })
            data.push(totals)
            */
            return { cols, data }
        },
    },
    methods: {
        ...mapActions('UniqueKeyModule', {
            authorize: 'authorize',
            setPermission: 'setPermission',
            setUniqueKey: 'setUniqueKey',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        showSuccessSnack(text) {
            this.resetSnackbarState()
            let payload = {
                typeMessage: 'success',
                message: {
                    title: 'Éxito',
                    body: text,
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
        showInfoSnack(text) {
            this.resetSnackbarState()
            let payload = {
                typeMessage: 'info',
                message: {
                    title: '',
                    body: text,
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
        showErrorSnack(text) {
            let payload = {
                typeMessage: 'error',
                message: {
                    title: 'Error',
                    body: text,
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
        commitFetchReport() {
            this.loading = true
            this.fetchReport()
                .then()
                .catch(e => this.showErrorSnack(this.getResponseError(e)))
                .finally(() => (this.loading = false))
        },
        fetchReport() {
            let route =
                process.env.VUE_APP_API_ROUTE + '/pos_receivable_payment_report'
            return new Promise((resolve, reject) =>
                axios
                    .post(route, {
                        start_date: this.initDate,
                        end_date: this.endDate,
                        branch_office_id: this.branchOfficeID,
                        pos_cash_desk_id: this.cashDeskID,
                    })
                    .then(r => {
                        if (
                            r &&
                            r.data &&
                            r.data.pos_receivable_payment_summary_report ===
                                'No encontrado'
                        )
                            return reject(
                                'No se registran pagos de clientes para el rango de fechas seleccionado'
                            )
                        this.data = r.data
                        resolve(true)
                    })
                    .catch(reject)
            )
        },
        getResponseError: e =>
            e && e.response && e.response.data && e.response.data.message
                ? e.response.data.message
                : e,
        formatDate(date) {
            let month = '' + (date.getMonth() + 1)
            let day = '' + date.getDate()
            let year = date.getFullYear()
            if (month.length < 2) month = '0' + month
            if (day.length < 2) day = '0' + day
            return [year, month, day].join('-')
        },
        initData() {
            //this.loading = true
            let date = new Date()
            this.initDate = this.formatDate(date)
            this.endDate = this.formatDate(date)
            /*
            this.fetchReport()
                .then()
                .catch(e => this.showErrorSnack(this.getResponseError(e)))
                .finally(() => (this.loading = false))
                */
        },
        auth() {
            this.loading = true
            this.authorize()
                .then(r => {
                    if (r.is_authorized) {
                        this.fetchReport()
                            .then()
                            .catch()
                            .finally(() => (this.loading = false))
                        this.showList = true
                        this.loading = false
                    } else {
                        this.$router.push('/')
                    }
                })
                .catch(console.log)
        },
        getXLSX() {
            let sheet = XLSX.utils.json_to_sheet(
                this.printData.data,
                this.printData.cols
            )
            var new_workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(new_workbook, sheet, 'SheetJS')
            let title = this.getTitle(this.branchOfficeName.toUpperCase() || '')
            XLSX.writeFile(new_workbook, `${title}.xlsx`)
        },
        getTitle(office_name) {
            let date = this.date
            if (this.date !== this.date2) date += `_AL_${this.date2}`
            let title = `REPORTE_PAGOS_${office_name}_${date}.xlsx`
            return title
        },
    },
    mounted() {
        this.setPermission(
            this.mixAuthCodePermissions.CREATE_AUTH_POS_DAILY_SALE_REPORT
        )
        document.getElementById('supervisor-modal-button').click()
    },
    created() {
        this.initData()
    },
}
</script>
